import React from 'react'
import lashesExtensionImg from "./../../../../../Images/Blog/Eyelash Extensions/Banner.png";

const LashesExtensionImg = () => {
  return (
    <div className="blogImg-content">
    <img src={lashesExtensionImg} alt="lashesExtensionImg" loading="lazy" />
  </div>
  )
}

export default LashesExtensionImg
